module.exports = __webpack_public_path__ + "7833c01e334d5dc38b30ff1f9db5c8c4.png";